/* eslint-disable @typescript-eslint/no-explicit-any */
import { environment } from '../../../environments/environment';

export function debounce(delay = environment.DELAY_SHORTEST): MethodDecorator {
  return function (_target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor {
    const original = descriptor.value;
    const key = `__timeout__${String(propertyKey)}`;

    descriptor.value = function (...args: any[]) {
      clearTimeout((this as any)[key]);
      (this as any)[key] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}
